/**
 * Creates a `rotate` transformation string with the given angle.
 *
 * @param angle The angle of rotation
 */
export const getRotateTransform = (angle: number | string | undefined): string | undefined => {
  return angle !== undefined ? `rotate(${angle})` : undefined;
};
